<template>
    <ListenerTrackLibrary v-if="isListenerMobile" />
    <TrackLibrary v-else />
</template>

<script>
import TrackLibrary from './TrackLibrary.vue'
import ListenerTrackLibrary from './ListenerTrackLibrary.vue'

export default {
    name: 'tracks',
    components: {
        TrackLibrary,
        ListenerTrackLibrary
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
